/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ridge_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you have many groups in a natural order — months, ages, categories — and want to see how the distribution shifts or spreads across them in a compact space.`)
};

const es_ridge_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando tienes muchos grupos en un orden natural — meses, edades, categorías — y quieres ver cómo se desplaza o dispersa la distribución entre ellos en un espacio compacto.`)
};

const de_ridge_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du viele Gruppen in einer natürlichen Reihenfolge hast — Monate, Altersgruppen, Kategorien — und sehen möchtest, wie sich die Verteilung darüber hinweg verschiebt oder ausbreitet, auf kompaktem Raum.`)
};

const nl_ridge_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wanneer je veel groepen hebt in een natuurlijke volgorde — maanden, leeftijden, categorieën — en wilt zien hoe de verdeling verschuift of zich verspreidt over deze groepen in een compacte ruimte.`)
};

const fr_ridge_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorsque vous avez de nombreux groupes dans un ordre naturel — mois, âges, catégories — et que vous voulez voir comment la distribution se déplace ou s'étend entre eux dans un espace compact.`)
};

const it_ridge_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando hai molti gruppi in un ordine naturale — mesi, età, categorie — e vuoi vedere come la distribuzione si sposta o si allarga tra di essi in uno spazio compatto.`)
};

const pt_br2_ridge_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando você tem muitos grupos em uma ordem natural — meses, idades, categorias — e quer ver como a distribuição se desloca ou se espalha entre eles em um espaço compacto.`)
};

const pt_ridge_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando tem muitos grupos numa ordem natural — meses, idades, categorias — e quer ver como a distribuição se desloca ou se espalha entre eles num espaço compacto.`)
};

const ja_ridge_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月、年齢、カテゴリなど自然な順序を持つ多数のグループがあり、それらの間で分布がどのように移動・拡散するかをコンパクトな空間で見たいときに使います。`)
};

const zh_ridge_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当你有许多按自然顺序排列的组——月份、年龄、类别——并希望在紧凑的空间内查看分布如何在它们之间变化或扩散时。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ridge_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ridge_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ridge_faq_a2", locale)
	if (locale === "en") return en_ridge_faq_a2(inputs)
	if (locale === "es") return es_ridge_faq_a2(inputs)
	if (locale === "de") return de_ridge_faq_a2(inputs)
	if (locale === "nl") return nl_ridge_faq_a2(inputs)
	if (locale === "fr") return fr_ridge_faq_a2(inputs)
	if (locale === "it") return it_ridge_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_ridge_faq_a2(inputs)
	if (locale === "pt") return pt_ridge_faq_a2(inputs)
	if (locale === "ja") return ja_ridge_faq_a2(inputs)
	return zh_ridge_faq_a2(inputs)
};